import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Topbar.module.css';

const MenuIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootMenuIcon, className);

  return (
    <svg className={classes} width="33" height="33" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter
          x="-.7%"
          y="-11.8%"
          width="101.2%"
          height="129.2%"
          filterUnits="objectBoundingBox"
          id="a"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.563100962 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g filter="url(#a)" transform="translate(-18 -18)" fill="#FEFEFE" fillRule="nonzero">
        <path d="M23.417 47.334a2.326 2.326 0 0 1-1.708-.709A2.326 2.326 0 0 1 21 44.917c0-.695.236-1.278.709-1.75a2.328 2.328 0 0 1 1.708-.708c.695 0 1.278.236 1.75.708s.708 1.055.708 1.75c0 .667-.236 1.236-.708 1.708-.472.473-1.055.709-1.75.709Zm10.75 0a2.326 2.326 0 0 1-1.708-.709 2.326 2.326 0 0 1-.709-1.708c0-.695.236-1.278.709-1.75a2.328 2.328 0 0 1 1.708-.708c.667 0 1.236.236 1.708.708.473.472.709 1.055.709 1.75 0 .667-.236 1.236-.709 1.708a2.326 2.326 0 0 1-1.708.709Zm10.75 0c-.695 0-1.278-.236-1.75-.709a2.328 2.328 0 0 1-.708-1.708c0-.695.236-1.278.708-1.75s1.055-.708 1.75-.708c.667 0 1.236.236 1.708.708.473.472.709 1.055.709 1.75 0 .667-.236 1.236-.709 1.708a2.326 2.326 0 0 1-1.708.709Zm-21.5-10.75a2.326 2.326 0 0 1-1.708-.709A2.326 2.326 0 0 1 21 34.167c0-.667.236-1.236.709-1.708a2.326 2.326 0 0 1 1.708-.709c.695 0 1.278.236 1.75.709.472.472.708 1.041.708 1.708s-.236 1.236-.708 1.708c-.472.473-1.055.709-1.75.709Zm10.75 0a2.326 2.326 0 0 1-1.708-.709 2.326 2.326 0 0 1-.709-1.708c0-.667.236-1.236.709-1.708a2.326 2.326 0 0 1 1.708-.709c.667 0 1.236.236 1.708.709.473.472.709 1.041.709 1.708s-.236 1.236-.709 1.708a2.326 2.326 0 0 1-1.708.709Zm10.75 0c-.695 0-1.278-.236-1.75-.709a2.328 2.328 0 0 1-.708-1.708c0-.667.236-1.236.708-1.708.472-.473 1.055-.709 1.75-.709.667 0 1.236.236 1.708.709.473.472.709 1.041.709 1.708s-.236 1.236-.709 1.708a2.326 2.326 0 0 1-1.708.709Zm-21.5-10.709a2.328 2.328 0 0 1-1.708-.708c-.473-.472-.709-1.055-.709-1.75 0-.667.236-1.236.709-1.708A2.326 2.326 0 0 1 23.417 21c.695 0 1.278.236 1.75.709.472.472.708 1.041.708 1.708 0 .695-.236 1.278-.708 1.75s-1.055.708-1.75.708Zm10.75 0a2.328 2.328 0 0 1-1.708-.708c-.473-.472-.709-1.055-.709-1.75 0-.667.236-1.236.709-1.708A2.326 2.326 0 0 1 34.167 21c.667 0 1.236.236 1.708.709.473.472.709 1.041.709 1.708 0 .695-.236 1.278-.709 1.75a2.328 2.328 0 0 1-1.708.708Zm10.75 0c-.695 0-1.278-.236-1.75-.708s-.708-1.055-.708-1.75c0-.667.236-1.236.708-1.708.472-.473 1.055-.709 1.75-.709.667 0 1.236.236 1.708.709.473.472.709 1.041.709 1.708 0 .695-.236 1.278-.709 1.75a2.328 2.328 0 0 1-1.708.708Z" />
      </g>
    </svg>
  );
};

const { string } = PropTypes;

MenuIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

MenuIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default MenuIcon;
